import template from './taskTrigger.html';

function TaskTriggerController(confirmationDialog) {
  const $ctrl = this;

  $ctrl.deleteTrigger = (id) => {
    confirmationDialog.confirm('CONFIRM_DELETE_TASK_TRIGGER', () => {
      $ctrl.delete({ triggerId: id });
    });
  };
}

const controllerArr = [
  'confirmationDialog',
  TaskTriggerController
];

const taskTrigger = {
  template,
  bindings: {
    trigger: '<',
    groupId: '@',
    delete: '&'
  },
  controller: 'TaskTriggerController'
};

export default function (ngModule) {
  ngModule.component('taskTrigger', taskTrigger);
  ngModule.controller('TaskTriggerController', controllerArr);
}
